'use client';

import dynamic from 'next/dynamic';

export const HappyContest = dynamic(
  () =>
    import(/* webpackChunkName: 'HappyContest' */ './HappyContest.client').then(
      (mod) => mod.HappyContest,
    ),
  {
    ssr: false,
  },
);
